module.exports = __webpack_public_path__ + "media/connected.4ad8bf09.wav";